import { useState } from "react";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

export default function AuthScreen({ waiting, errorMessage, onSignIn }) {
  const [busy, setBusy] = useState(false);

  const handleLogin = async () => {
    setBusy(true);
    try {
      await onSignIn();
    } finally {
      setBusy(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        bgcolor: "background.default",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          pt: 1.5,
          px: 4,
          pb: 4,
          width: "100%",
          maxWidth: 360,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 2,
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            pb: 2,
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          <Box
            component="img"
            src="/assets/images/logos/entra-banner-logo.png"
            alt="Poder Judicial de Mendoza"
            sx={{
              display: "block",
              maxHeight: 56,
              maxWidth: 280,
              objectFit: "contain",
            }}
          />
        </Box>
        <Typography variant="h5" fontWeight={600}>
          P-USHER
        </Typography>
        <Typography variant="body2" color="text.secondary" textAlign="center">
          Ingresá con tu cuenta institucional
        </Typography>
        {waiting ? (
          <CircularProgress size={28} sx={{ my: 1 }} />
        ) : (
          <>
            {errorMessage && (
              <Alert severity="error" sx={{ width: "100%" }}>
                {errorMessage}
              </Alert>
            )}
            <Button
              variant="contained"
              fullWidth
              onClick={handleLogin}
              disabled={busy}
              sx={{ mt: 2 }}
            >
              {busy ? "Ingresando..." : "Ingresar"}
            </Button>
          </>
        )}
      </Paper>
    </Box>
  );
}
